export default "__VITE_ASSET__a52a3144__"